import { useQuery } from '@tanstack/react-query';
import { CompanyAppendix } from '../types';

export const useCompanyAppendices = () => {
  const { data, isLoading, refetch, error, isError } = useQuery<CompanyAppendix[]>({
    queryKey: ['company-appendices'],
  });

  return {
    appendices: data ?? [],
    isLoading,
    refetch,
    error,
    isError,
  };
};
